module.exports = __webpack_public_path__ + "img/14.0888bed.png";